import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';
import { Trigger } from './lib/trigger';
import { Filter } from './lib/filter';
import { Accordion } from './lib/accordion';
import { Sort } from './lib/sort';
import { AutoAnimate } from './lib/auto-animate';

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

window.Alpine = Alpine
window.Accordion = Accordion;
window.Sort = Sort;

Alpine.plugin( collapse )
Alpine.start()

objectFitImages();

const animate = new AnimateObserver();
animate.init();

const trigger = new Trigger();
trigger.init();

const filters = new Filter();
filters.init();

const autoAnimate = new AutoAnimate();
autoAnimate.init();
